














import {
  computed,
  defineComponent,
  onMounted,
  onUnmounted,
  PropType,
  watch,
  WritableComputedRef
} from "@vue/composition-api"
import AuthenticationModal from "./components/ModalComponent.vue"
import AuthenticationComponent from "@/apps/MyStudyChoiceAuthenticationWidget/components/AuthenticationComponent.vue"
import {Config} from "./models/config-viewmodel";
import {useActions, useGetters} from "vuex-composition-helpers";
import {useAuthenticationExchangeBus} from "@/shared/composables/authenticationExchangeBus";

export default defineComponent({
    name: "MyStudyChoiceAuthenticationWidget",
    components: {AuthenticationComponent, AuthenticationModal},
    props: {
        config: {
            type: Object as PropType<Config>,
            required: true
        }
    },
    setup: (props) => {
        const {setConfig} = useActions(['setConfig']);
        const {toggleAuthenticationWidgetVisible} = useActions(['toggleAuthenticationWidgetVisible'])

        setConfig(props.config)
        const {getAuthenticationWidgetToggle} = useGetters([
            'getAuthenticationWidgetToggle'
        ])

      const authBus = useAuthenticationExchangeBus();

        const authentication: WritableComputedRef<any> = computed({
            get(): any {
                return getAuthenticationWidgetToggle.value
            },
            set(value: boolean): void {
                toggleAuthenticationWidgetVisible(value)
            }
        });

        const config = { attributes: true, childList: true, subtree: true };
        const callback = (mutationList: any, observer: any) => {
            for (const mutation of mutationList) {
                if (mutation.type === "childList") {
                    init()
                }
            }
        }
        const observer = new MutationObserver(callback);

        function init(): void {
            document.querySelectorAll(props.config.eventListener).forEach((el) => {
                el.addEventListener('click', (event: any) => {
                    authentication.value = true
                })
            })
          if (authBus.active) {
                authentication.value = true
            authBus.active = false
            }
        }

        watch(
            () => authBus.active,
            (newState: boolean, oldState: boolean) => {
                if(newState) {
                    authentication.value = true
                  authBus.active = false
                }
            }
        )

      function closeAndRedirectModal(): void {
        authBus.favoriteStudyCode = null;

            let urlParams = new URLSearchParams(window.location.search)
            let goBack = urlParams.get('goBack')
            if (goBack != null && goBack === 'true') {
                history.back()
            } else {
                authentication.value = !authentication.value
            }
        }

        onMounted(async () => {
            if (!props.config.eventListener) {
                authentication.value = true
            } else {
                observer.observe(document.body, config);
            }
        })
        onUnmounted(() => {
            observer.disconnect()
        })

        return {
            authentication,
            closeAndRedirectModal
        }
    }
})
